import Model from '@/models/Model.js';

export default class Integration extends Model {
    static entity = 'integration';
    static modelName = 'Integration';

    static fields() {
        return {
            id: this.attr(null),

            // Polymorphic relation
            integratable_id: this.attr(null),
            integratable_type: this.attr(null),
            integratable: this.morphTo('integratable', 'integratable_type', 'integratable_id'),

            // Integration fields
            service_name: this.attr(''),
            type: this.attr(''),
            description: this.attr(''),
            service_text: this.attr(''),

            is_enabled: this.attr(false),
            is_configured: this.attr(false),
        };
    }
}
